<template>
  <div ref="box" :style="{ display: direction === 'X' ? 'table' : '' }">
    <slot></slot>
    <slot v-if="num > limit"></slot>
  </div>
</template>

<script>
export default {
  props: {
    // 控制滚动速度
    speed: {
      type: Number,
      default: 1,
    },
    // 控制鼠标移入滚动停止
    isMouseControl: {
      type: Boolean,
      default: true,
    },
    // 高度偏差【padding,margin】
    deviation: {
      type: Number,
      default: 5,
    },
    // 滚动方向
    direction: {
      type: String,
      default: 'Y',
    },
    // 数据量
    num: {
      type: Number,
      default: 0,
    },
    // 限制，多少条数据开始滚动
    limit: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      height: 0,
      width: 0,
      isScroll: true,
    }
  },
  computed: {
    firstSlot() {
      return this.$refs.box.children[0] || {}
    },
    secondSlot() {
      return this.$refs.box.children[1] || {}
    },
    boxHeight() {
      return this.$refs.box.clientHeight || 0
    },
    boxWidth() {
      return this.$refs.box.clientWidth || 0
    },
  },
  mounted() {
    if (this.num <= this.limit) return
    if (this.direction === 'Y') {
      this.startY(this.height)
      if (this.isMouseControl) {
        this.setEvent()
      }
    } else {
      this.startX(this.width)
      if (this.isMouseControl) {
        this.setEvent()
      }
    }
  },
  methods: {
    setEvent() {
      this.$refs.box.onmouseenter = () => {
        this.isScroll = false
      }
      this.$refs.box.onmouseleave = () => {
        this.isScroll = true
        if (this.direction === 'Y') {
          this.$nextTick(() => {
            this.startY(this.height)
          })
        } else {
          this.$nextTick(() => {
            this.startX(this.width)
          })
        }
      }
    },
    startY(height) {
      this.firstSlot.style = `transform:translate${this.direction}(-${height}px);`
      this.secondSlot.style = `height:${this.boxHeight}px;transform:translate${this.direction}(-${height}px);overflow:hidden;`
      if (height >= this.firstSlot.clientHeight + this.deviation) {
        this.$emit('reset')
      } else {
        this.height += this.speed
      }
      if (!this.isScroll) return
      window.requestAnimationFrame(() => {
        this.startY(this.height)
      })
    },
    startX(width) {
      this.firstSlot.style = `transform:translate${this.direction}(-${width}px);`
      this.secondSlot.style = `width:${this.boxWidth}px;transform:translate${this.direction}(-${width}px);overflow:hidden;`
      if (width >= this.firstSlot.clientWidth + this.deviation) {
        this.$emit('reset')
      } else {
        this.width += this.speed
      }
      if (!this.isScroll) return
      window.requestAnimationFrame(() => {
        this.startX(this.width)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
